import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useClearDiagram } from 'src/containers/ProjectDiagram/hooks/useClearDiagram';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ModelConceptHierarchyLink } from 'src/containers/ProjectDiagram/types/diagram';
import { addDeletedData } from 'src/containers/ProjectDiagram/utils/addDeletedData';
import {
  DiagramModelCommitLayout,
  commitDiagramModel,
} from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { cleanupModelConceptHierarchyMappings } from 'src/containers/ProjectDiagram/utils/mapping/cleanupModelConceptHierarchyMappings';
import { removeModelConceptHierarchy } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/removeModelConceptHierarchy';
import * as copy from 'src/templates/copy';

type HierarchyContextMenuProps = {
  link: ModelConceptHierarchyLink;
};

export const HierarchyContextMenu: React.VFC<HierarchyContextMenuProps> = ({
  link,
}) => {
  const diagram = useDiagram();
  const clearDiagram = useClearDiagram();

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={() => {
          if (!diagram) {
            return;
          }

          clearDiagram();
          commitDiagramModel(
            diagram,
            (model) => {
              addDeletedData([link.data])(model);
              removeModelConceptHierarchy(link.data)(model);
              cleanupModelConceptHierarchyMappings(model);
            },
            { layout: DiagramModelCommitLayout.PARTIAL }
          );
        }}
        text={copy.components.projectDiagram.contextMenu.delete}
      />
    </Menu>
  );
};
